import { useMutation } from 'react-apollo'
import { DeletePartnerProjectPackage } from '../../../graphql/packages/mutations'

/**
 *  Removes a package (aka orderset) from a partner project

 * @returns Package
 */

export const useMutationDeletePartnerProjectPackageApi = () => {
  const [
    deletePartnerProjectPackage,
    {
      data: deletePartnerProjectPackageData,
      error: deletePartnerProjectPackageError,
      loading: deletePartnerProjectPackageLoading,
    },
  ] = useMutation(DeletePartnerProjectPackage, {})

  return [
    deletePartnerProjectPackage,
    {
      data: deletePartnerProjectPackageData,
      error: deletePartnerProjectPackageError,
      loading: deletePartnerProjectPackageLoading,
    },
  ] as const
}
